<template>
	<div class="container-fluid">
		<div class="" v-show="errors !== null">
			<save-error
				@close="errors = null"
				:errors="errors"
				:text="'Figyelem! A kért módosítások nem kerültek mentésre, mert nem került minden kötelező mező kitöltésre vagy egyes mezők nem felelnek meg a formai elvárásoknak! Kérjük javítsa az alábbiakat és mentse újra!'"
			/>
		</div>
		<div class="row d-flex justify-content-center align-items-center mt-2">
			<div class="col-12">
				<div class="row d-flex justify-content-center align-items-center">
					<div class="col-6 col-sm-6 col-md-2 text-center">
						<div class="mui-checkbox">
						    <label>
						      <input type="checkbox" value="" v-model="customer.aktiv">
						      Aktív
						      <span v-if="inquiring">érdeklődő</span>
						      <span v-else>ügyfél</span>
						    </label>
						</div>
					</div>
					<div class="col-6 col-sm-6 col-md-1">
						<div class="mui-textfield mui-textfield">
					    	<input type="number" v-model="customer.regio">
					    	<label>Régiókód</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-6 col-md-2">
						<div class="mui-select">
						    <select v-model="customer.kategoria_id">
						      <option v-for="(k,index) in kat" :key="index" :value="k.kszam">{{k.nev}}</option>
						    </select>
						    <label>Kategória</label>
						</div>
					</div>
					<div class="col-12 col-sm-6 col-md-2">
						<div class="mui-select">
						    <select v-model="customer.tipus_id">
						      <option
						      	v-for="(k,index) in tip"
						      	:key="index"
						      	:value="k.kszam"
						      	:disabled="k.fortype != fortype"
						      >
						      	{{k.nev}}
						      </option>
						    </select>
						    <label>Típus</label>
						</div>
					</div>
					<div class="col-12 col-sm-6 col-md-2">
						<span class="small">Számla-kiállítási szolgáltató</span>
						<select v-model="customer.szolgaltato" class="form-control">
						    <option
						    	v-for="(sz,index) in szolg"
						    	v-show="sz.aktiv ==1"
						    	:key="index"
						    	:value="sz.id"
						    >
								{{ sz.nev }}
							</option>
						</select>
					</div>
				</div>

				<div class="row d-flex justify-content-center align-items-center">
					<div class="col-12 col-sm-6 col-md-2">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="customer.min">
					    	<label>Minimum rendelés</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-6 col-md-1">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="customer.datum_limit">
					    	<label>Ciklusidő (nap)</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-6 col-md-2">
						<div class="mui-select">
						    <select v-model="customer.szla_tipus">
							    <option
									v-for="(item,index) in szla_tipusok"
									:key="`sz-${index}`"
									:value="item.id"
									:disabled="item.id === 0"
								>
									{{item.nev}}
								</option>
						    </select>
						    <label>Fizetési mód</label>
						</div>
					</div>
					<div class="col-12 col-sm-12 col-md-3">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="customer.nev">
					    	<label>Név</label>
					  	</div>
					</div>
				</div>

				<div class="row d-flex justify-content-center align-items-center">
					<div class="col-12 col-sm-4 col-md-1">
						<div class="mui-textfield mui-textfield">
					    	<input type="number" v-model="customer.iszam">
					    	<label>Irányítószám</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-8 col-md-2">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="customer.varos">
					    	<label>Város</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-12 col-md-3">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="customer.cim">
					    	<label>Cím</label>
					  	</div>
					</div>

					<div class="col-12 col-sm-12 col-md-1">
						<label>
					      <input type="checkbox" value="" v-model="customer.lift_nincs">
					      Lift nincs
					    </label>
					</div>

					<div class="col-1">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="customer.cim_utca">
					    	<label>Utca</label>
					  	</div>
					</div>
					<div class="col-1">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="customer.cim_hsz">
					    	<label>Házszám</label>
					  	</div>
					</div>
					<div class="col-1">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="customer.cim_ea">
					    	<label>Emelet / Ajtó</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-6 col-md-2">
						<div class="row d-flex justify-content-center no-gutters">
							<div class="col-6 col-lg-12">
								<button
									class="btn btn-outline-primary btn-sm m-1"
									@click.prevent="copycim"
								>
									Cím másolása szállítási címhez
								</button>
							</div>
							<div class="col-6 col-lg-12">
								<button
									class="btn btn-outline-primary btn-sm m-1"
									@click.prevent="copyszamlazasi"
								>
									Cím másolása számlázási címhez
								</button>
							</div>
						</div>
					</div>
				</div>

				<div class="row d-flex justify-content-center align-items-center mt-2">
					<div class="col-12 col-sm-6 col-md-3">
						<div class="mui-textfield mui-textfield">
							<input-mask
								v-model="customer.telm"
								:mask="'99 99 999 9999'"
								maskChar="_"
							>
							</input-mask>
					    	<label>Telefon 1</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-6 col-md-3">
						<div class="mui-textfield mui-textfield">
					    	<input-mask
								v-model="customer.telv"
								:mask="'99 99 999 9999'"
								maskChar="_"
							>
							</input-mask>
					    	<label>Telefon 2</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-6 col-md-3">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="customer.email">
					    	<label>E-mail cím</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-6 col-md-3">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="customer.emaila">
					    	<label>E-mail cím 2</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-6 col-md-3">
						<div class="mui-checkbox">
							<label>
								<input type="checkbox" value="" v-model="customer.sendVoiceMail">
								Hangüzenet-kiküldése
							</label>
						</div>
					</div>

					<!--<div class="col-12 col-sm-6 col-md-3">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="customer.emaila">
					    	<label>Kapcsolattartó e-mail cím</label>
					  	</div>
					</div>
					-->
				</div>
				
				<div class="row d-flex justify-content-center">
					<div class="col-12 col-md-10">
						<div class="mui-textfield">
						    <textarea v-model="customer.megj"></textarea>
						    <label>Megjegyzés</label>
						</div>
					</div>
					<div class="col-12 col-md-2" v-if="!inquiring">
						<order-history
							class="btn-lg"
		                	:id="customer.uszam"
		              	>
		              	</order-history>
					</div>
				</div>
			</div>

			<div class="col-12">
				<div class="card mb-2">
				  <div class="card-header">
				  	<span class="text-left">
				  		Automata adatok
				  	</span>
				  </div>
				  <div class="card-body">
				  	<div class="row d-flex justify-content-center">
					    <div class="col-6 col-sm-6 col-md-3 text-center">
							<div class="mui-checkbox">
							    <label>
							      <input type="checkbox" value="" v-model="customer.automataa">
							      Automata {{automata}}
							    </label>
							</div>
						</div>
						<div class="col-6 col-sm-6 col-md-3 text-center">
							<div class="mui-checkbox">
							    <label>
							      <input type="checkbox" value="" v-model="customer.automata_szerzodes" :disabled="!customer.automataa">
							      Szerződés az automatára {{automata_szerz}}
							    </label>
							</div>
						</div>
						<div class="col-12 col-sm-12 col-md-6">
							<div class="mui-textfield mui-textfield">
						    	<input type="text" v-model="customer.automata" :disabled="!customer.automataa">
						    	<label>Automata leírás</label>
						  	</div>
						</div>
					</div>
				  </div>
				</div>
			</div>

			<div class="col-12">
				<div class="card mb-2">
				  <div class="card-header">
				  	<span class="text-left">
				  		Szállítási cím
				  	</span>
				  </div>
				  <div class="card-body">
				  	<div class="row d-flex justify-content-center align-items-center">
						<div class="col-12 col-sm-4 col-md-1">
							<div class="mui-textfield mui-textfield">
						    	<input type="number" v-model="customer.szaliszam">
						    	<label>Irányítószám</label>
						  	</div>
						</div>
						<div class="col-12 col-sm-8 col-md-2">
							<div class="mui-textfield mui-textfield">
						    	<input type="text" v-model="customer.szalvaros">
						    	<label>Város</label>
						  	</div>
						</div>
						<div class="col-12 col-sm-12 col-md-3">
							<div class="mui-textfield mui-textfield">
						    	<input type="text" v-model="customer.szalcim">
						    	<label>Cím</label>
						  	</div>
						</div>
						<div class="col-12 col-sm-12 col-md-2">
							<div class="mui-textfield mui-textfield">
						    	<input type="text" v-model="customer.szal_cim_utca">
						    	<label>Utca</label>
						  	</div>
						</div>
						<div class="col-12 col-sm-6 col-md-1">
							<div class="mui-textfield mui-textfield">
						    	<input type="text" v-model="customer.szal_cim_hsz">
						    	<label>Házszám</label>
						  	</div>
						</div>
						<div class="col-12 col-sm-6 col-md-1">
							<div class="mui-textfield mui-textfield">
						    	<input type="text" v-model="customer.szal_cim_ea">
						    	<label>Emelet / Ajtó</label>
						  	</div>
						</div>
					</div>
				  </div>
				</div>
			</div>

			<div class="col-12">
				<div class="card mb-2">
				  <div class="card-header">
				  	<span class="text-left">
				  		Számlázási adatok
				  	</span>
				  </div>
				  <div class="card-body">
				  	<div class="row d-flex justify-content-center">
					    <div class="col-12 col-sm-12 col-md-8">
							<div class="mui-textfield mui-textfield">
						    	<input type="text" v-model="customer.cegnev">
						    	<label>Cégnév</label>
						  	</div>
						</div>
						<div class="col-12 col-sm-12 col-md-4">
							<div class="mui-textfield mui-textfield">
						    	<input type="text" v-model="customer.cegadoszam">
						    	<label>Cég adószám</label>
						  	</div>
						</div>
						<div class="col-12 col-sm-4 col-md-1">
							<div class="mui-textfield mui-textfield">
						    	<input type="number" v-model="customer.cegiszam">
						    	<label>Cég irányítószám</label>
						  	</div>
						</div>
						<div class="col-12 col-sm-8 col-md-2">
							<div class="mui-textfield mui-textfield">
						    	<input type="text" v-model="customer.cegvaros">
						    	<label>Cég város</label>
						  	</div>
						</div>
						<div class="col-12 col-sm-12 col-md-4">
							<div class="mui-textfield mui-textfield">
						    	<input type="text" v-model="customer.cegcim">
						    	<label>Cég cím</label>
						  	</div>
						</div>
						<div class="col-12 col-sm-12 col-md-2">
							<div class="mui-textfield mui-textfield">
						    	<input type="text" v-model="customer.ceg_utca">
						    	<label>Utca</label>
						  	</div>
						</div>
						<div class="col-12 col-sm-6 col-md-1">
							<div class="mui-textfield mui-textfield">
						    	<input type="text" v-model="customer.ceg_hsz">
						    	<label>Házszám</label>
						  	</div>
						</div>
						<div class="col-12 col-sm-6 col-md-1">
							<div class="mui-textfield mui-textfield">
						    	<input type="text" v-model="customer.ceg_ea">
						    	<label>Emelet / Ajtó</label>
						  	</div>
						</div>
					</div>

					<div class="row d-flex justify-content-center" v-if="!inquiring">
						<div class="col-12 col-sm-6 col-md-3">
						    <div class="mui-checkbox">
							    <label>
							      	<input type="checkbox" value="" v-model="customer.eszamla"
							    	>
							      	E-számla küldése
							    </label>
						    </div>
						</div>
						<div class="col-12 col-sm-6 col-md-3" v-if="customer.email != ''">
						    <div class="mui-checkbox">
							    <label>
							      	<input type="checkbox" value="" v-model="customer.eszamla1email"
							    	>
							      	{{ customer.email }}
							    </label>
						    </div>
						</div>
						<div class="col-12 col-sm-6 col-md-3" v-if="customer.emaila != ''">
						    <div class="mui-checkbox">
							    <label>
							      	<input type="checkbox" value="" v-model="customer.eszamla2email"
							    	>
							      	{{ customer.emaila }}
							    </label>
						    </div>
						</div>
					</div>
				  </div>
				</div>
			</div>
			<div class="col-12">
				<div class="card mb-2">
				  <div class="card-header">
				  	<span class="text-left">
				  		Ügyfél WEB-es rendelési felületre való belépési adatai
				  	</span>
				  </div>
				  <div class="card-body">
						<div class="row d-flex justify-content-center align-items-center">
							<div class="col-12 col-sm-12 col-md-2 text-center">
								<div class="mui-checkbox">
								    <label>
								      <input type="checkbox" value="" v-model="customer.web_auth">
								      Webes belépés								      
								      <span v-show="!customer.web_auth">nincs engedélyezve</span>
								      <span v-show="customer.web_auth">engedélyezve</span>
								    </label>
								</div>
							</div>
							<div class="col-12 col-sm-6 col-md-5">
								<div class="mui-textfield mui-textfield">
							    	<input type="text" v-model="customer.web_user" :disabled="!customer.web_auth">
							    	<label>Belépési név</label>
							  	</div>
							</div>
							<div class="col-12 col-sm-6 col-md-5">
								<div class="mui-textfield mui-textfield">
							    	<input type="text" v-model="customer.jelszo" :disabled="!customer.web_auth">
							    	<label>Jelszó</label>
							  	</div>
							</div>
						</div>
				  </div>
				</div>
			</div>
			<div class="col-12" v-if="change&&customer.uszam&&!inquiring">
				<billingo-id
					:customer="customer"
				>
				</billingo-id>
			</div>

			<div class="col-12" v-if="change&&!inquiring">
				<div class="card mb-2">
				  	<div class="card-header">
				  		<span class="text-left">
				  			Ügyfél számlái
				  		</span>

				  		<span class="float-right pointer">
							<i
								class="fa-solid fa-lg fa-chevron-down"
								v-if="show_body_szla == false"
								@click="show_body_szla = true"
							>
							</i>
							<i
								class="fa-solid fa-lg fa-chevron-up"
								v-if="show_body_szla == true"
								@click="show_body_szla = false"
							>
							</i>
						</span>
				  	</div>
				  	<div class="card-body" v-if="show_body_szla">
				  		<div class="table-responsive" v-if="invoices.length != 0">
				  			<table class="table table-striped table-invoice">
				  				<thead>
				  					<th>Számla kelte</th>
				  					<th>Számla sorszáma</th>
				  					<th>Rendelésszám</th>
				  					<th>Szolgáltató</th>
				  					<th>Megtekintés</th>
				  				</thead>
				  				<tbody>
				  					<tr
				  						v-for="(v,k) in invoices"
				  						:key="k"
				  					>
				  						<td>{{ v.invoice_date }}</td>
				  						<td>{{ v.invoice_number }}</td>
				  						<td>{{ v.rendelesszam }}</td>
				  						<td>{{ v.szolgaltato }}</td>
				  						<td>
				  							<i
				  								class="far fa-eye pointer"
				  								@click.prevent="selected = v"
				  							>
				  							</i>
				  						</td>
				  					</tr>
				  				</tbody>
				  			</table>
				  		</div>
				  		<div v-else>
				  			<div class="h4 text-center">
				  				Nincs számla ehhez az ügyfélhez
				  			</div>
				  		</div>
				  		<component
							:is="selected?'invoice':null"
							:invoice="selected"
							@close="close"
						>
						</component>
				  	</div>
				</div>
			</div>
		</div>
		<div class="m-2">
			<div class="row d-flex justify-content-center">
				<div class="col-12 col-md-2" v-if="!change&&inquiring">
					<div class="mui-textfield">
					    <input type="number" v-model="taskDay">
					    <label>Feladat határideje (nap)</label>
					</div>
				</div>
				<div
					class="text-center"
					:class="[!change&&inquiring ? 'col-12 col-md-10' : 'col-12']"
				>
					<button class="btn btn-success btn-lg" @click.prevent="save">
						<span v-if="change">Mentés</span>
						<span v-if="!change&&!inquiring">Ügyfél rögzítés</span>
						<span v-if="!change&&inquiring">Érdeklődő rögzítés</span>
					</button>
					<button
						class="btn btn-success btn-lg"
						@click.prevent="save"
						v-if="!change&&!inquiring"
					>
						Ügyfél rögzítés, utána új rendelés rögzítése
					</button>
					<button
						class="btn btn-success btn-lg"
						v-if="change&&inquiring"
						@click.prevent="toCustomer(false)"
					>
						Legyen ügyfél
					</button>
					<button
						class="btn btn-success btn-lg"
						v-if="change&&inquiring"
						@click.prevent="toCustomer(true)"
					>
						Legyen ügyfél, utána új rendelés rögzítése
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import moment from 'moment'
import invoice from '@/components/invoice'
import billingoId from '@/components/customers/customer_billingo'
import {mapActions} from 'vuex'
export default {
	name: 'customer_data',

	props: ['change','id','user','inquiring'],

	components: {
		invoice,
		billingoId
	},

	data() {
		return {
			customer: {},
			kat: [],
	    	tip: [],
	    	szolg: [],
	    	show_ceg: false,
	    	show_szall: false,
	    	show_web: false,
	    	show_automata: false,
	    	errors: null,
	    	invoices: [],
	    	selected: null,
	    	taskDay: 8,
	    	show_body_szla: false
	    	//telMask: [/(\d{4})(\d{3})(\d{4})/,/(\d{4})(\d{3})(\d{3})/,/(\d{3})(\d{3})(\d{4})/]
	    }
	},

	created(){
		this.$Progress.start()
	    this.req.post('/others')
	      	.then(res => {
		      	this.kat = res.data.kat
		      	this.tip = res.data.tip
		      	this.szolg = res.data.szolg
		      	this.$Progress.finish()
		    })
	      	.catch(err => {
	      		console.log(err)
	      		this.$Progress.fail()
	      	})

	    if(this.change) {
	    	this.$Progress.start()
	    	this.req.post(this.loadUrl,{
	    		id: this.id
	    	})
	    		.then(res => {
	    			this.customer = res.data.customer
	    			this.invoices = res.data.invoices
	    			this.$Progress.finish()
	    		})
	    		.catch(err => {
	    			console.log(err)
	    			this.$Progress.fail()
	    		})
	    } else {
	    	this.clear_customer()
	    	if(this.inquiring) {
	    		this.customer.aktiv = true
	    		this.customer.kategoria_id = 2
	    		this.customer.tipus_id = 5
	    	}
	    }
	},

	methods: {
		...mapActions(['setrendselcustomer']),

		close() {
			this.selected = null
		},

		copycim(){
			this.customer.szalcim = this.customer.cim != undefined ? this.customer.cim : ``
			this.customer.szaliszam = this.customer.iszam != undefined ? this.customer.iszam : ``
			this.customer.szalvaros = this.customer.varos != undefined ? this.customer.varos : ``
			this.customer.szal_cim_utca = this.customer.cim_utca != undefined ? this.customer.cim_utca : ``
			this.customer.szal_cim_hsz = this.customer.cim_hsz != undefined ? this.customer.cim_hsz : ``
			this.customer.szal_cim_ea = this.customer.cim_ea != undefined ? this.customer.cim_ea : ``
			/*this.customer.cegiszam = this.customer.iszam != undefined ? this.customer.iszam : ``
			this.customer.cegvaros = this.customer.varos != undefined ? this.customer.varos : ``
			this.customer.cegcim = this.customer.cim != undefined ? this.customer.cim : ``
			this.customer.ceg_utca = this.customer.cim_utca != undefined ? this.customer.cim_utca : ``
			this.customer.ceg_hsz = this.customer.cim_hsz != undefined ? this.customer.cim_hsz : ``
			this.customer.ceg_ea = this.customer.cim_ea != undefined ? this.customer.cim_ea : ``*/
		},

		copyszamlazasi(){
			this.customer.cegnev = this.customer.nev != undefined ? this.customer.nev : ''
			this.customer.cegiszam = this.customer.iszam != undefined ? this.customer.iszam : ''
			this.customer.cegvaros = this.customer.varos != undefined ? this.customer.varos : ''
			this.customer.cegcim = this.customer.cim != undefined ? this.customer.cim : ''
			this.customer.ceg_utca = this.customer.cim_utca != undefined ? this.customer.cim_utca : ''
			this.customer.ceg_hsz = this.customer.cim_hsz != undefined ? this.customer.cim_hsz : ''
			this.customer.ceg_ea = this.customer.cim_ea != undefined ? this.customer.cim_ea : ''
		},

		save(){
			this.$Progress.start()
			this.errors = null
	    	this.req.post(this.saveUrl, {
	    		customer: this.customer,
	    		user: this.user,
	    		change: this.change,
	    		taskDay: this.taskDay
	    	})
	    		.then(res => {
	    			if (res.data.status == 'error') {
	    				this.errors = res.data.errors
	    				if(res.data.errors == null) toastr.error(res.data.text)
	    				console.log(res.data.sql)
	    			} else {
	    				if (!this.change && !this.inquiring) {
	    					this.clear_customer()
	    					this.req.post('/customers/getdata',{
					    		id: res.data.id
					    	})
					    		.then(response => {
					    			this.setrendselcustomer(response.data.customer)
					    			this.$router.replace('/orders/new_order/products')
					    		})
	    				}
	    				if (!this.change && this.inquiring) {
	    					this.$router.replace('/')
	    				}
	    				toastr.success(`${this.change?'Mentés':'Hozzáadás'} sikeres`)
	    			}
	    			this.$Progress.finish()
	    		})
	    		.catch(err => {
	    			console.error(err)
	    			toastr.error(err)
	    			this.$Progress.fail()
	    		})
		},

		clear_customer(){
			this.customer = {
				id: null,
				user: '',
				prio: '',
				datum: '',
				udatum: '',
				udatum_jellege: '',
				uszam: '',
				kapcsolattarto_id: 0,
				nev: '',
				varos: '',
				iszam: '',
				cim: '',
				telv: '',
				telm: '',
				email: '',
				emaila: '',
				emailb: '',
				emailc: '',
				web_user: '',
				jelszo: '',
				min: '',
				datum_limit: '',
				atlag_ido: '',
				automata: '',
				automataa: 0,
				automata_szerzodes: 0,
				regio: '',
				cegnev: '',
				cegvaros: '',
				cegiszam: '',
				cegcim: '',
				cegadoszam: '',
				szalvaros: '',
				szaliszam: '',
				szalcim: '',
				megj: '',
				megj1: '',
				web_auth: 0,
				aktiv: 0,
				utolso_elotti_rend_datum: '0000-00-00',
				utolso_elotti_rend_termek: '0',
				utolso_elotti_rend_darab: 0,
				utolso_rend_termek: '',
				utolso_rend_darab: 0,
				kategoria: '',
				kategoria_id: null,
				tipus_id: null,
				cim_utca: '',
				szal_cim_utca: '',
				ceg_utca: '',
				cim_hsz: '',
				szal_cim_hsz: '',
				ceg_hsz: '',
				cim_ea: '',
				szal_cim_ea: '',
				ceg_ea: '',
				szolgaltato: null,
				check: 0,
				szla_tipus: 1,
				billingo_id: null,
				inquiring: 0,
				eszamla: 0,
				eszamla2email: 0,
				eszamla1email: 0
			}
		},

		toCustomer(val) {
			this.$Progress.start()
			this.req.post('/inquiring/toCustomer', {
				customer: this.customer
			})
				.then(res => {
					if(!val) {
						this.$router.replace(`/customer/${this.customer.id}`)
					} else {
						let id = this.$route.params.id
						this.clear_customer()
    					this.req.post('/customers/getdata',{
				    		id: id
				    	})
				    		.then(response => {
				    			this.setrendselcustomer(response.data.customer)
				    			this.$router.replace('/orders/new_order/products')
				    		})
					}
				})
				.catch(err => {
	    			console.error(err)
	    			toastr.error(err.response.data.text || err)
	    			this.$Progress.fail()
	    		})
		}
	},

	computed: {
		fortype() {
			return this.$route.path.includes('customer') ? 'customer' : 'inquiring'
		},

		saveUrl() {
			return this.inquiring ? '/inquiring/save' : '/customers/save'
		},

		loadUrl() {
			return this.inquiring ? '/inquiring/getdata' : '/customers/getdata'
		},

		automata(){
			return this.customer.automataa ? 'van' : 'nincs'
		},

		automata_szerz(){
			return this.customer.automata_szerzodes ? 'van' : 'nincs'
		},

		add_customer(){
			var cus = this.customer
			cus.user = this.user
			return cus
		}
	}
}
</script>

<style type="text/css" scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/customers/customer_data.vue